import React from 'react';
import { Immutable } from 'nuclear-js';
import moment from 'moment';
import CommonStrings from 'resources/common-strings';
import PropTypes from 'prop-types';
import CreateReactClass from 'create-react-class';

import GrowthGoalsUtils from './utils';
import GrowthUtils from '../utils';
import TermUtils from 'utils/terms';
import Analytics from 'utils/analytics';
import CommonValues from 'resources/common-values';

export default CreateReactClass({
    displayName: 'PastGrowthGoals',

    propTypes: {
        currentGrowthGoals: PropTypes.instanceOf(Immutable.List),
        pastGrowthGoals: PropTypes.instanceOf(Immutable.List),
        deleteGoal: PropTypes.func.isRequired,
        showActionPlanModal: PropTypes.func,
    },

    getInitialState() {
        return {
            expandedYn: true,
        };
    },

    renderPreviousGrowthGoalsHeader() {
        const header = (
            <div key="header-previous-growth-goal" className="row-goal-grid-header left-border">
                <span key="term">Term</span>
                <span key="actual-score">Actual Score</span>
                <span key="set-goal">Set Goal</span>
                <span key="typical-growth">Projected Growth</span>
                <span key="starting-score">Starting Score</span>
                <span key="edit-info">Set On/by</span>
                <span key="goal-met" className="border-right">
                    Goal Met?
                </span>
                <span className="screen-only"></span>
            </div>
        );

        return header;
    },

    renderPreviousGrowthGoals(pastGrowthGoals) {
        let goalRows = [],
            growthGoals = [];

        if (pastGrowthGoals) {
            growthGoals = pastGrowthGoals.sortBy((s) => s.get('endTermNumber')).reverse();
        }

        if (growthGoals.size > 0) {
            growthGoals.forEach((goal) => {
                const actualScore = goal.get('endTermScore') ? `${goal.get('endTermScore')}` : CommonStrings.blanks;
                const goalStatus = GrowthUtils.goalStatus(goal);
                const typicalGrowth = GrowthGoalsUtils.typicalGrowth(goal);
                const startingScore = GrowthGoalsUtils.startingScore(goal, true);
                const metGoalColumnClass = 'goals-met-grid-content goal-status ' + goalStatus.className;
                const getTermToText = TermUtils.textFromTermNumber(goal.get('endTermNumber'), true);
                const getActionPlan = goal.get('actionPlan')
                    ? GrowthGoalsUtils.safeDecodeUri(goal.get('actionPlan'))
                    : undefined;

                goalRows.push(
                    <div key={goal.get('growthGoalBid')} className="row-goal-grid-content row-past-goal">
                        <span className="goal-termDate">{getTermToText ? getTermToText : ''}</span>
                        <span>{actualScore}</span>
                        <span>{goal.get('targetScore')}</span>
                        <span className={typicalGrowth.className}>{typicalGrowth.description}</span>
                        <span className={startingScore.className}>{startingScore.description}</span>
                        <span>
                            {moment.utc(goal.get('dateEdited')).format('MM/DD/YYYY')}
                            <br />
                            {goal.get('educatorName')}
                            <br />
                            {goal.get('actionPlan') ? (
                                <a
                                    onClick={() =>
                                        this.props.showActionPlanModal(
                                            goal.get('actionPlan'),
                                            goal.get('growthGoalBid')
                                        )
                                    }
                                    className="screen-only"
                                >
                                    Action Plan >
                                </a>
                            ) : (
                                ''
                            )}
                        </span>
                        <span className={metGoalColumnClass}>{goalStatus.description}</span>
                        <span className="button-goal-delete screen-only" onClick={() => this.props.deleteGoal(goal)}>
                            Delete
                        </span>
                        {getActionPlan ? (
                            <span key={'print-' + goal.get('growthGoalBid')} className="print-only action-plan">
                                {getActionPlan}
                            </span>
                        ) : null}
                    </div>
                );
            });
        } else {
            goalRows.push(
                <div
                    key={'past-goal-no-content-' + Math.floor(Math.random() * 10000)}
                    className="print-only row-goal-grid-content row-past-goal"
                >
                    There are no previous goals for this student.
                </div>
            );
        }

        goalRows.push(<p key="print-section-divider" className="print-only section-divider" />);
        return goalRows;
    },

    renderPreviousGoals(pastGrowthGoals) {
        if (this.state.expandedYn) {
            return [this.renderPreviousGrowthGoalsHeader(), this.renderPreviousGrowthGoals(pastGrowthGoals)];
        } else {
            return null;
        }
    },

    render() {
        const hasItems = this.props.pastGrowthGoals && this.props.pastGrowthGoals.size > 0;
        return (
            <div className={hasItems ? '' : 'print-only'}>
                <div
                    key="previous-growth-goal"
                    className={hasItems ? 'goals-section past-goal-section-break' : 'goals-section'}
                    id={this.props.id}
                >
                    <div key="previous-goal-title" className="goal-title">
                        <button
                            className={
                                this.state.expandedYn
                                    ? 'goal-chevron expand-chevron-up'
                                    : 'goal-chevron expand-chevron-down'
                            }
                            onClick={() => {
                                if (this.state.expandedYn) {
                                    Analytics.recordButtonClick(
                                        CommonValues.SectionIDs.growthGoals,
                                        'previous-goals-toggle',
                                        'open'
                                    );
                                } else {
                                    Analytics.recordButtonClick(
                                        CommonValues.SectionIDs.growthGoals,
                                        'previous-goals-toggle',
                                        'close'
                                    );
                                }
                                this.setState({ expandedYn: !this.state.expandedYn });
                            }}
                        />
                        Previous Growth Goals
                    </div>

                    <div
                        key="previous-growth-goal"
                        className={
                            hasItems ? 'growth-goal-header-background' : 'print-only growth-goal-header-background'
                        }
                    />
                    <div key="previous-growth-goal-container" className="growth-goal container">
                        {this.renderPreviousGoals(this.props.pastGrowthGoals)}
                    </div>
                </div>
            </div>
        );
    },
});
